import React, { useState } from 'react';
import { sendSubscriptionRequest } from '../api/contact';

const Newsletter = () => {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [showError, setShowError] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    setShowError(false);
    try{
      await sendSubscriptionRequest(email)
      setShowSuccess(true);
      setEmail('');
      // Hide success message after 5 seconds
      setTimeout(() => setShowSuccess(false), 5000);
    }catch{
      setShowError(true);
      // Hide error message after 5 seconds
      setTimeout(() => setShowError(false), 5000);
    }finally {
      setIsLoading(false);
    };
  };

  return (
    <section className="py-16 bg-[#F8F5F0] mx-4 sm:mx-6 lg:mx-8 mb-16">
      {/* Success Alert */}
      {showSuccess && (
        <div className="fixed inset-x-0 top-[50px] mx-auto w-max z-50">
          <div className="border border-gray-200 shadow-lg rounded-lg px-6 py-4 items-center w-[350px] h-[120px] bg-[#CEEAD6]">
            <div className='flex'>
              <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12.185" cy="12.185" r="12.185" fill="#17752C"/>
                <path d="M17.861 8.27349C18.1792 8.56721 18.1792 9.08122 17.861 9.37494L11.595 15.641C11.3012 15.9592 10.7872 15.9592 10.4935 15.641L7.36048 12.508C7.04228 12.2142 7.04228 11.7002 7.36048 11.4065C7.6542 11.0883 8.16821 11.0883 8.46193 11.4065L11.0565 13.9766L16.7595 8.27349C17.0533 7.95529 17.5673 7.95529 17.861 8.27349Z" fill="white"/>
              </svg>
              <p className="font-semibold text-gray-900 ml-4 pb-3">Success</p>
            </div>
            <div>
              <p className="font-medium text-[13.88px] leading-[19.27px] tracking-[-2%] text-black/40">Thank you for subscribing! 🎉 You'll now receive the latest insights directly to your inbox.</p>
            </div>
          </div>
        </div>
      )}

      {/* Error Alert */}
      {showError && (
        <div className="fixed top-4 right-4 z-50">
          <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative" role="alert">
            <strong className="font-bold">Error! </strong>
            <span className="block sm:inline">Failed to send message. Please try again.</span>
            <span className="absolute top-0 bottom-0 right-0 px-4 py-3" onClick={() => setShowError(false)}>
              <svg className="fill-current h-6 w-6 text-red-500" role="button" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                <title>Close</title>
                <path d="M14.348 14.849a1.2 1.2 0 0 1-1.697 0L10 11.819l-2.651 3.029a1.2 1.2 0 1 1-1.697-1.697l2.758-3.15-2.759-3.152a1.2 1.2 0 1 1 1.697-1.697L10 8.183l2.651-3.031a1.2 1.2 0 1 1 1.697 1.697l-2.758 3.152 2.758 3.15a1.2 1.2 0 0 1 0 1.698z"/>
              </svg>
            </span>
          </div>
        </div>
      )}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row lg:flex-row items-start gap-6 lg:gap-0">
          {/* Heading */}
          <h3 className="text-[21.6px] font-medium flex-1 block lg:flex">
            <div>Stay ahead.</div> <div className='pl-[0spx] lg:pl-[5px]'>Get insights that matter.</div>
          </h3>

          {/* Form */}
          <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-[15px] w-full lg:w-auto lg:ml-auto flex-1 justify-end">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter Email"
              className="w-full sm:w-64 h-[50px] px-4 py-2 border-none text-gray-700 placeholder-gray-500 focus:outline-none text-[15.82px]"
              required
            />
            <button
              type="submit"
              className="h-[50px] bg-black text-white px-6 py-2 hover:bg-gray-800 transition-colors text-[15.82px] font-medium flex items-center"
              onClick={() => handleSubmit}
            >
              {isLoading ? (
                  <>
                    <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    Subscribing...
                  </>
                ) : (
                  <>
                    Subscribe
                  </>
                )
              }
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Newsletter;
